import React, { type FC, useState } from "react";
import { useApiCall } from "../api/api";
import type { Company } from "../api/dto";
import { Input } from "../components/form/Input";
import { ModalFooter } from "../components/layout/ModalProvider";
import { useRefresh } from "../components/RefreshController";

export const RenameCompanyAliasModal: FC<{ company: Company }> = (props) => {
  const { updateCompany } = useApiCall();
  const refresh = useRefresh();
  const [alias, setAlias] = useState(props.company.alias);
  const save = async () => {
    await updateCompany(
      props.company.id,
      props.company.name,
      props.company.scoringOverride ?? undefined,
      alias,
    );
    refresh();
  };
  return (
    <div>
      <Input type={"text"} label={"Alias"} value={alias} onChange={setAlias} />
      <ModalFooter text={"Opslaan"} onSubmit={save} />
    </div>
  );
};
